/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

// import * as actions from '../actions/index';
// import { demoShipments } from '../util/demoShipments'
// import { dummyDataContainerInfo, coors } from '../util/testJSON'
// import { shipmentListData, shipmentActivityDetail, shipmentsCurrentLocation } from '../data/shipmentData'
import { saveEntryTypeField, saveEntryTypeDateField, saveDutiesNonMerchandise } from '../api/setFormData'

const initialState = {
  // initialValues
}

export default function EntryTypeReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_ENTRY_TYPE': {
      return Object.assign({}, {}, { ...action.payload })
    }
    case 'UPDATE_ENTRY_TYPE_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'UPDATE_SUMMARY_DATE_FIELD': {
      return Object.assign({}, state, {
        summaryDate: Object.assign({}, state.summaryDate, {
          epochs: action.payload
        })
      })
    }

    case 'UPDATE_ENTRY_TYPE_OBJECT': {
      let newObject = Object.assign({}, state[action.object], {
        [action.field]: action.value
      })
      return Object.assign({}, state, {
        [action.object]: newObject
      })
    }
    case 'UPDATE_ENTRY_DATE_FIELD': {
      return Object.assign({}, state, {
        entryDate: Object.assign({}, state.entryDate, {
          epochs: action.payload
        })
      })
    }
    case 'UPDATE_FTZ_DATE_FIELD': {
      return Object.assign({}, state, {
        ftzFilingDate: Object.assign({}, state.ftzFilingDate, {
          epochs: action.payload
        })
      })
    }
    // case 'UPDATE_ACTOR_ADDRESS': {
    //   return Object.assign({}, state, { ...action.payload })
    // }
    case 'INITIALIZE_SHIPID': {
      return Object.assign({}, state, { shipId: action.payload })
    }
    case 'SAVE_ENTRY_TYPE_FIELD': {
      if (action.field === 'entryType') {
        const shouldResetMpfOverride = !["11", "12"]?.includes(action.payload) && state?.mpfOverrideFlag == "1";
        let eventMessage = {
          "entryTypeInfo": {
            "entryType": action.payload,
            ...(shouldResetMpfOverride && { mpfOverrideFlag: "0" }),
          }
        }
        saveDutiesNonMerchandise(eventMessage)
      } else {
        saveEntryTypeField([action.field], action.payload, state.shipId).then(
          response => {
            if (action.field === "mpfOverrideFlag") {
              let eventMessage = {
                "entryTypeInfo": {
                  "entryType": state.entryType,
                }
              }
              saveDutiesNonMerchandise(eventMessage)
            }
          }
        )
      }
      return state
    }
    case 'SAVE_ENTRY_TYPE_DATE_FIELD': {
      return (
        saveEntryTypeDateField(
          [action.field],
          action.payload,
          state.shipId
        ).then(response => console.log(response)),
        Object.assign({}, state, {
          [action.field]: Object.assign({}, ...[action.field], {
            epochs: action.payload
          })
        })
      )
    }
    case 'UPDATE_ENTRY_TYPE_WARNING': {
      return Object.assign({}, state, { warning: action.warnings })
    }
    default:
      return state
  }
}
